import React, { useContext } from 'react';
import SidebarItem from './components/SidebarItem';
import { ICustomerLocalizationGroup } from 'types';
import { ILocalizationContext, LocalizationContext } from '../../../../localizationState/localizationContext';
import style from './Sidebar.module.scss';

interface ISidebar {
	items: ICustomerLocalizationGroup[];
}

const Sidebar: React.FC<ISidebar> = ({ items }) => {
	const { setGroup, selectedGroup } = useContext<ILocalizationContext>(LocalizationContext);

	return (
		<>
			{items.length ? (
				<div className={style.container} data-test="Sidebar">
					{items.map((el) => (
						<SidebarItem
							key={el.id}
							label={el.name || ''}
							isActive={selectedGroup?.id === el.id}
							onClick={() => setGroup(el)}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default Sidebar;
